function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.196 1.913C9.331-.45 5.16-.332 2.432 2.19c-2.727 2.523-3.17 6.673-1.036 9.714l5.455 7.773c.142.202.374.323.621.323.248 0 .48-.12.622-.323l5.455-7.773c2.208-3.177 1.62-7.515-1.353-9.99zm.453 9.36l-5.176 7.376-5.177-7.377C.452 8.644.87 5.052 3.266 2.917c2.398-2.135 6.015-2.135 8.412 0 2.398 2.135 2.815 5.727.971 8.355h0z",
  transform: "translate(-120 -347) translate(120 347) translate(5 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.473 3.746c-2.138 0-3.872 1.733-3.872 3.87 0 2.139 1.734 3.872 3.872 3.872s3.87-1.733 3.87-3.871c-.002-2.137-1.733-3.869-3.87-3.871zm0 6.643c-1.122 0-2.133-.675-2.562-1.711-.429-1.036-.191-2.229.601-3.021.793-.793 1.986-1.03 3.021-.601 1.036.429 1.712 1.44 1.712 2.56-.002 1.531-1.242 2.771-2.772 2.773z",
  transform: "translate(-120 -347) translate(120 347) translate(5 2)"
})))));

var SvgIconAdreslerim = function SvgIconAdreslerim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdreslerim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-adreslerim.068edfe1.svg";
export { ForwardRef as ReactComponent };